import { gsap, ScrollTrigger } from "./utilities/gsap";
import LazyLoad from "vanilla-lazyload";

import Numcounter from "./components/numcounter";
import Sliders from "./components/sliders";
import StepperJS from "./components/stepper";

import Home from "./pages/home";

import "jquery-match-height";
import Accordion from "./components/Accordion";

gsap.config({
    nullTargetWarn: false   
})

document.fonts.ready.then(() => {
    Numcounter();
})

const lazyLoadInstance = () => {
    new LazyLoad({
        elements_selector: `.wp-block-image img`,
        use_native: true
    });

    new LazyLoad({
        elements_selector: `.lazy`,
        use_native: true
    });
}

window.onload = function() {
    lazyLoadInstance();
    Sliders();
    StepperJS();
    Accordion();
    Home()
}